<div class="col-12 confirmation-section">
    <div class="section-title">Payment method</div>
    <div class="section-detail-wrapper">
        <div class="section-details-header">BPAY payment details</div>
        <div class="section-detail-value">
            Pay from your bank account via internet or phone banking using the following details:
        </div>
        <div class="section-detail-subhead">
           Amount to pay: 
        </div>
        <div class="section-detail-value">
            {{getPaymentAmount()}}
        </div>
        <div class="section-detail-subhead">
            Biller code:
        </div>
        <div class="section-detail-value">
            {{summary?.bpayBillerCode}}
        </div>
        <div class="section-detail-subhead">
            Customer reference:
        </div>
        <div class="section-detail-value">
            {{summary?.bpayReference}}
        </div>
    </div>
</div>